import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import { GAME_TYPE, MUSIC } from '../../helper/constant';
import { MapService } from '../../services/map.service';

declare const playSound: any;
let that;
let soundMute = false;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    @Input() language = 'en';
    @Input() game_type = GAME_TYPE;
    @Input() videoLink = '';
    @Input() external = true;
    keyArray = '';
    keyGenNumber = {
        num1: 0,
        num2: 0,
        sum: 0
    };
    keySum = 0;
    help = false;
    parent = false;
    answerLengh = 0;

    constructor(private router: Router,
                private translateService: TranslateService,
                private mapService: MapService) {
        that = Object.create(this.constructor.prototype);
    }

    async ngOnInit() {
        soundMute = this.mapService.getSoundConfig();
        setTimeout(() => {
            $('.popup-close').click((e) => {
                // this.playSounds(MUSIC.select);
                $('.header-video-help .phu-huynh').fadeOut(200);
                $('.popup-box').removeClass('transform-in').addClass('transform-out');
                e.preventDefault();
            });

            $('.clickvideo').click((e) => {
                $('.header-video-help').fadeIn(200);
                $('.popup-box').removeClass('transform-out').addClass('transform-in');
                e.preventDefault();
            });
            $('.clicksetting').click((e) => {
                $('.phu-huynh').fadeIn(200);
                $('.popup-box').removeClass('transform-out').addClass('transform-in');
                e.preventDefault();
            });
            this.initKeyParent();
        }, 50);
    }

    keysToString() {
        let str = '';
        if (this.keyGenNumber.sum < 10) {
            str = '?';
        } else {
            str = '??';
        }
        return this.keyArray.length ? this.keyArray : str;
    }

    keyGen() {
        this.keyGenNumber.num1 = Math.floor(Math.random() * 20);
        this.keyGenNumber.num2 = Math.floor(Math.random() * 10);
        this.keyGenNumber.sum = this.keyGenNumber.num1 + this.keyGenNumber.num2;
        return this.keyGenNumber.sum.toString().length;
    }

    keyLock(key: number) {
        this.playSounds(MUSIC.button);
        this.keyArray += key.toString();
        this.keySum = parseInt(this.keyArray, 10);
        if (this.keyArray.length >= this.answerLengh) {
            if (this.keySum === this.keyGenNumber.sum) {
                setTimeout(() => {
                    this.goPageDetail('setting', '');
                }, 500);
            } else {
                this.keyArray = '';
                this.answerLengh = this.keyGen();
            }
        }

    }

    // }).catch(error => console.log(error));

    goPageDetail(page: string, data: any) {
        this.playSounds(MUSIC.button).catch(e => console.log(e));
        this.parent = false;
        this.router.navigate([page], { queryParams: data });
    }

    goBack() {
        this.playSounds(MUSIC.button).catch(e => console.log(e));
        this.goPageDetail('game-type', this.game_type.basic);

    }

    actionOnClickHelp() {
        this.mapService.stopMusic();
        this.playSounds(MUSIC.button).catch(e => console.log(e));
        // this.playSounds(MUSIC.select);
        if (this.videoLink && this.videoLink.length > 0) {
            this.help = true;
            $('.clickvideo').click((e) => {
                $('.header-video-help').fadeIn(200);
                $('.popup-box').removeClass('transform-out').addClass('transform-in');
                e.preventDefault();
            });
        }
    }

    actionOnSetting() {
        this.initKeyParent();
        this.parent = true;
        this.playSounds(MUSIC.button).catch(e => console.log(e));
        $('.clicksetting').click((e) => {
            $('.phu-huynh').fadeIn(200);
            $('.popup-box').removeClass('transform-out').addClass('transform-in');
            e.preventDefault();
        });
    }

    closeVideo() {
        this.mapService.resumeMusic();
        setTimeout(() => {
            this.help = false;
        }, 200);
    }

    closeSetting() {
        setTimeout(() => {
            this.parent = false;
        }, 200);

    }

    playSounds(file: string) {
        return new Promise((resolve, reject) => {
            soundMute = this.mapService.getSoundConfig();
            if (soundMute === true) {
                playSound(file).then(() => {
                    resolve('ok');
                }).catch(e => {
                    reject();
                });
            } else {
                resolve('ok');
            }
        });
    }

    initKeyParent() {
        this.keyArray = '';
        this.answerLengh = this.keyGen();
    }
}
